var map = {
	"./icon-cypress.svg": 3166,
	"./icon-drupal.svg": 3399,
	"./icon-figma.svg": 223,
	"./icon-git.svg": 635,
	"./icon-html.svg": 8810,
	"./icon-javascript.svg": 2316,
	"./icon-linkedin.svg": 7123,
	"./icon-react.svg": 1770,
	"./icon-sass.svg": 163,
	"./icon-smacss.svg": 5411,
	"./icon-webpack.svg": 4322
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6723;